import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import UserView from 'components/layout/client/UserView';
import Breadcrumb from 'components/layout/Breadcrumb';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

import { ROLE_EMPLOYEE, ROLE_COMPANY } from 'js/constants';
import may from 'js/security';

class Profile extends React.Component {
  render() {
    const {
      intl: { messages },
      urlPrefix,
      user,
    } = this.props;

    const breadcrumb = (
      <DocMeta tags={generateMetaTags(messages.meta.profile)}>
        {may(ROLE_EMPLOYEE, user.roles) || may(ROLE_COMPANY, user.roles) ? (
          <Breadcrumb
            crumbs={[
              { link: urlPrefix + 'account', name: 'Dashboard' },
              { link: urlPrefix + 'account/settings', name: messages.settings },
              { link: urlPrefix + 'account/settings/profile', name: messages.profile },
            ]}
            className="p-t-0"
          />
        ) : (
          <Breadcrumb
            crumbs={[
              { link: urlPrefix + 'account', name: 'Dashboard' },
              { link: urlPrefix + 'account/settings/profile', name: messages.profile },
            ]}
            className="p-t-0"
          />
        )}
      </DocMeta>
    );

    return <UserView clientId={user.username} clientData={user} editSelf breadcrumb={breadcrumb} />;
  }
}

const mapStateToProps = state => {
  return {
    user: state.login.user,
    urlPrefix: state.intl.urlPrefix,
  };
};

export default injectIntl(connect(mapStateToProps)(Profile));
